module.exports = __webpack_public_path__ + "img/8.7de5d017.jpg";